const mutations = {
    // 添加页签
    pushPageTab(state, tabItem) {
        state.pageTabs.push(tabItem);
    },
    delPageTab(state, targetName) {
        state.pageTabs = state.pageTabs.filter(tab => tab.name !== targetName);
    },
    // 修改当前选中页签值
    changePageTabValue(state, tabValue) {
        state.pageTabValue = tabValue;
    },
    // 修改锚定状态值
    setAnchorShrinkState(state, shrinkVal) {
        state.anchorShrinkState = shrinkVal;
    },
    setCuranchorId(state, curId) {
        state.curAnchorId = curId;
    },
    setSidebarOpened(state, sidebarOpenedState) {
      state.sidebarOpened = sidebarOpenedState;
    },
    setLoadingState(state, loadingState) {
        state.loadingState = loadingState;
    }
}

export default mutations;


// WEBPACK FOOTER //
// ./src/store/mutations.js